import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const piliers = [
  { key: 'pourquoi_1', icon: 'ri-fire-line' },
  { key: 'pourquoi_2', icon: 'ri-award-line' },
  { key: 'pourquoi_3', icon: 'ri-shield-check-line' },
  { key: 'pourquoi_4', icon: 'ri-file-shield-line' },
];

export default function PourquoiNous() {
  const { t } = useTranslation('toitplat');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="pourquoi-nous" className="bg-soft-gray py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <div
          className={`text-center mb-12 md:mb-16 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="font-manrope font-bold text-slate-primary text-2xl md:text-3xl lg:text-4xl">
            {t('pourquoi_h2')}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {piliers.map((p, idx) => (
            <div
              key={idx}
              className={`bg-white rounded-xl p-5 md:p-6 text-center transition-all duration-700 hover:-translate-y-1 hover:shadow-sm ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: `${idx * 120 + 200}ms` }}
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-copper/10 mx-auto mb-4">
                <i className={`${p.icon} text-copper text-2xl`} />
              </div>
              <h3 className="font-manrope font-bold text-slate-primary text-sm md:text-base mb-2">
                {t(`${p.key}_title`)}
              </h3>
              <p className="text-slate-primary/60 text-xs md:text-sm leading-relaxed">
                {t(`${p.key}_desc`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}